<template>
  <div class="d-flex justify-center">
    <aside
      class="d-none d-lg-flex flex-column left-col mr-8"
    >
      <slot name="left" />
    </aside>
    <div class="w-100 flex-grow-1 right-col d-flex flex-column">
      <slot name="right" />
    </div>
  </div>
</template>

<script lang="ts">

import { defineComponent } from 'vue'

export default defineComponent({
  name: 'RootGridRow'
})
</script>

<style lang="scss" scoped>
.left-col {
  width: 184px !important;
}

.right-col {
  max-width: 100%;
}

/* lg-and-up */
@media (min-width: map.get(vars.$grid-breakpoints, 'lg')) {
  .right-col {
    max-width: calc(#{map.get(vars.$container-max-widths, 'lg')} - 184px - 32px - 32px) !important;
  }
}

/* xl-only: approximate as min-width xl and max-width just before 2xl */
@media (min-width: #{map.get(vars.$grid-breakpoints, 'xl')}) {
  .left-col {
    width: 240px !important;
  }
  .right-col {
    max-width: calc(#{map.get(vars.$container-max-widths, 'xl')} - 240px - 32px - 32px) !important;
  }
}
</style>
